import React from "react";
import PropTypes from "prop-types";
import { styled, keyframes } from "@mui/material/styles";

const InfiniteSpinning = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Loader = styled("div")`
  font-size: 16px;
  position: relative;
  z-index: 1000;
  width: 12.5em;
  height: 12.5em;
`;

const Spinner = styled("div")(props => ({
  position: "absolute",
  animation: `${InfiniteSpinning} 1s linear infinite`,
  width: "10em",
  height: "10em",
  top: "1.25em",
  left: "1.25em",
  borderRadius: "10em",
  boxShadow: `0 0.25em 0 0 ${props.theme.eclipseLoader[props.color]}`,
  transformOrigin: "5em 5.125em"
}));

function EclipseLoader({ color }) {
  return (
    <Wrapper>
      <Loader>
        <Spinner color={color} />
      </Loader>
    </Wrapper>
  );
}

EclipseLoader.propTypes = {
  color: PropTypes.string.isRequired
};

export default EclipseLoader;
